<div class="select-schools-container">
  <div class="overlay-color">
    <div class="form-container">
      <div class="container-logo">
        <img class="login-logo" src="assets/logos/logo-agenda-group-7479.svg" />
      </div>
      <div class="text-center">
        <p>Selecione uma unidade para continuar</p>
      </div>
      <div class="schools-list-container" *ngIf="schools.length > 0 && !loading">
        <button class="school-button" mat-raised-button *ngFor="let school of schools"
          [disabled]="loading"
          (click)="selectSchool(school)">
          {{ school.name }}
        </button>
      </div>
      <mat-progress-bar *ngIf="loading" mode="indeterminate" class="effect-mid mat-loading"></mat-progress-bar>
    </div>
  </div>
</div>